/**
 * @desc 查询订单成交量详情 总量，竞价成交量，挂牌成交量 type:1 煤炭 2 再生资源 3 焦化,4石料
 */
import { OrderCoalQuantityDetail } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryOrderCoalQuantityDetailParameter = {
  type?: number
}

const method = 'GET'
const url = '/trade/order/mall/queryOrderQuantityDetail'

export const queryOrderCoalQuantityDetailApi = (
  params?: QueryOrderCoalQuantityDetailParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<OrderCoalQuantityDetail>({
    method,
    url,
    params,
    ...config
  })
}

queryOrderCoalQuantityDetailApi.method = method
queryOrderCoalQuantityDetailApi.url = url
